interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({
  title = 'Something went wrong',
  message = 'We couldn’t load that. Try again?',
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-8 py-16 text-center">
      <div className="mb-3 text-amber-500" aria-hidden="true">
        <svg
          width={36}
          height={36}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.6}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </div>
      <h2 className="text-base font-semibold text-ink-900 dark:text-[#E2E8F0]">{title}</h2>
      <p className="mt-1 max-w-xs text-sm text-ink-500 dark:text-[#94A3B8]">{message}</p>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 inline-flex h-11 min-w-[120px] items-center justify-center rounded-full bg-ss-blue px-5 text-sm font-semibold text-white transition-colors hover:bg-ss-blue-dark"
        >
          Try again
        </button>
      ) : null}
    </div>
  );
}
